export default "__VITE_ASSET__72c65085__"